import { render, staticRenderFns } from "./EditGroup.vue?vue&type=template&id=e0232658&scoped=true&"
import script from "./EditGroup.vue?vue&type=script&lang=ts&"
export * from "./EditGroup.vue?vue&type=script&lang=ts&"
import style0 from "./EditGroup.vue?vue&type=style&index=0&id=e0232658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0232658",
  null
  
)

export default component.exports